import { selectHasActiveTurn, useChatStore } from '@/chat/hooks/use-chat-store';
import { useSuggestion } from '@/chat/hooks/use-suggestion';
import type { AssistantMessage } from '@/chat/types';
import { Message, MessageContent } from '@/components/ai-elements/message';
import { Spinner } from '@/components/ui/spinner';
import { ErrorBubble } from './error-bubble';
import { ReplacementResult } from './replacement-result';
import { SuggestionResult } from './suggestion-result';

export const AssistantBubble = ({ message }: { message: AssistantMessage }) => {
  const { retry } = useSuggestion();
  const hasActiveTurn = useChatStore(selectHasActiveTurn);

  return (
    <Message from="assistant">
      {(message.status === 'uploading' || message.status === 'analyzing') && (
        <MessageContent>
          <div className="text-muted-foreground flex items-center gap-2">
            <Spinner />
            <span>분석 중...</span>
          </div>
        </MessageContent>
      )}
      {message.status === 'completed' && (
        <MessageContent className="w-full">
          {message.type === 'replacement' ? (
            <ReplacementResult items={message.replacementItems} />
          ) : (
            <SuggestionResult items={message.items} />
          )}
        </MessageContent>
      )}
      {message.status === 'failed' && message.error && (
        <MessageContent>
          <ErrorBubble
            error={message.error}
            onRetry={() => void retry(message.id)}
            retryDisabled={hasActiveTurn}
          />
        </MessageContent>
      )}
    </Message>
  );
};
